<template>
  <main>
    <div class="banner-wrapper">
      <div class="banner-container">
        <Transition name="fade" mode="out-in">
          <div v-if="stage === 0" class="main-content" key="stage-0">
            <img src="@/assets/images/text-1.png" class="text-1" />
            <img src="@/assets/images/heading.png" class="heading" />
            <div class="coin-container">
              <img src="@/assets/images/limit.png" class="limit" />
              <img src="@/assets/images/flare.png" class="flare flare-1" />
              <div class="coin coin-1">
                <img src="@/assets/images/coin1.png" />
              </div>
              <img src="@/assets/images/flare.png" class="flare flare-2" />
              <div class="coin coin-2">
                <img src="@/assets/images/coin2.png" />
              </div>
              <img src="@/assets/images/zlato.png" class="zlato" />
            </div>
            <img src="@/assets/images/price.png" class="price" />
            <img src="@/assets/images/sale.png" class="sale" />
            <img src="@/assets/images/pointer.png" class="pointer" />
            <img src="@/assets/images/kolo.png" ref="wheel" class="wheel" />
            <img v-if="!spinning" @click="spin" src="@/assets/images/btn.png" class="btn main" />
            <img v-else src="@/assets/images/btn-empty.png" class="btn" />
            <a
              href="https://mojemincovna.cz/uploads/mailing/Pravidla-hry-AP-kolo-stesti-03-04.2026.pdf"
              target="_blank"
              ><img src="@/assets/images/rules.png" class="rules"
            /></a>
            <img src="@/assets/images/copy.png" class="copy" />
          </div>
          <div v-else class="main-content" key="stage-1">
            <img src="@/assets/images/congrats.png" class="congrats" />
            <div class="price-container">
              <img src="@/assets/images/60percent.png" class="percent" />
              <img src="@/assets/images/premie.png" class="premie" />
              <img src="@/assets/images/coins.png" class="coins" />
              <img src="@/assets/images/plus.png" class="plus" />
              <img src="@/assets/images/book.png" class="books" />
              <img src="@/assets/images/new-price.png" class="new-price" />
              <img src="@/assets/images/description.png" class="description" />
            </div>
            <a
              href="https://www.mojemincovna.cz/petihaler?utm_source=HF-EM-AP-CCCBM-2026-&utm_medium=EMAILING-&utm_campaign=HF-AP-03-04.2026-&utm_term=594850"
            >
              <img src="@/assets/images/claim.png" class="claim" />
            </a>
          </div>
        </Transition>
      </div>
    </div>
  </main>
</template>

<script setup>
import confetti from '@hiseb/confetti'
import { ref } from 'vue'
const wheel = ref(null)
const spinning = ref(false)
const stage = ref(0)
const spin = () => {
  spinning.value = true
  wheel.value.classList.add('spinning')
  setTimeout(() => {
    // stage.value = 1
    confetti({
      position: {
        x: window.innerWidth * 0.5,
        y: window.innerHeight * 0.71,
      },
      count: 500,
      size: 1,
      velocity: 200,
      fade: true,
    })
    setTimeout(() => {
      stage.value = 1
    }, 1000)
  }, 5000)
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.35s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
